<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 3, width: 9 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 14, y: 1, width: 9, reverse: true },
        ]"
      >
        <a-copy :cms="cms" :class="`${name}__copy`" />
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__media`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 13, width: 13 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 1, y: 1, width: 12, reverse: true },
        ]"
      >
        <grid
          :class="[`${name}__grid`, `${name}__squares`]"
          :layout="[
            {
              size: 1,
              columns: 'repeat(2, 1fr)',
              rows: 'repeat(2, 1fr)',
              gap: 0,
            },
          ]"
        >
          <component
            :is="item.component"
            v-for="item in cms.squares"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="[`${name}__square`]"
          />
        </grid>
      </grid-item>
    </grid>

    <a-image-v2
      v-if="(cms.image || {}).filename"
      :src="cms.image.filename"
      :alt="cms.image.alt"
      :layout="[
        { size: 0, bound: 667, ratio: [375, 667] },
        { size: 1, bound: 768, ratio: [1480, 833] },
        { size: 2, bound: 992, ratio: [1480, 833] },
        { size: 3, bound: 1200, ratio: [1480, 833] },
      ]"
      :class="`${name}__background`"
    />

    <component
      :is="item.component"
      v-for="item in cms.battenberg"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      :class="`${name}__battenberg`"
    />
  </section>
</template>

<script>
import ASvgLogoX9 from '@/components/atoms/a-svgs/a-svg-logo-x9'
import AImageV2 from '@/components/atoms/a-images/a-image-v2'
import MSquare from '@/components/molecules/m-square/m-square'
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-health/o-health-x4-sq.data'
export default {
  components: { ASvgLogoX9, AImageV2, MSquare },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? { ...data } : {}
      },
    },
  },

  data() {
    return {
      name: 'o-health-x4-sq',
      show: false,
    }
  },

  computed: {
    reverse() {
      return this.cms.reverse || false
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#212121'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || '',
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-health-x4-sq {
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  position: relative;
  overflow: hidden;

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__grid {
    align-items: center;
  }

  &__content {
    @include container();

    min-height: inherit;
    display: grid;
    z-index: 2;
  }

  &__media,
  &__media ::v-deep * {
    // height: 100%;
    z-index: 2;
  }

  &__background {
    position: absolute;
    width: 100%;
    height: 100%;

    ::v-deep img {
      filter: var(--filter);
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  &__copy {
    margin: 100px 0;

    ::v-deep p:last-child {
      margin-bottom: 0;
    }
  }

  &__battenberg {
    position: absolute;
    top: 0;
    left: 0;
    width: 102px;
    height: 102px;
  }

  &__squares ::v-deep .m-square {
    // min-height: 417px;
  }
}

@include media-breakpoint-up(lg) {
  .o-health-x4-sq {
    &__battenberg {
      width: 205px;
      height: 205px;
    }
  }
}
</style>
